module.exports = __webpack_public_path__ + "assets/images/9bfd8b8a912eddf3cf22ef7611c1e34d.png";